import React, { CSSProperties } from "react";

interface VerticalCenterProps {
  children: React.ReactNode;
  styles?: CSSProperties;
}

const VerticalCenter: React.FC<VerticalCenterProps> = ({ children, styles }) => {
  return (
    <div style={styles} className="flex flex-col justify-center h-full w-full">
      {children}
    </div>
  );
};

export default VerticalCenter;
